<template>
  <div class="flex min-w-[650px] py-2 justify-bewteewn items-center text-black-500 text-center">
    <div class="absolute w-[138px] px-6">
      <AppLinks :apps="apps" :selectedApp="appResolution"/>
    </div>
    <div class="w-full h-fit mx-[138px]">
      <div class="w-fit h-fit justify-self-center truncate bg-gray-200 rounded-lg py-2 px-8">
        {{ footerCopyrightText }}
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import Constants from '@/constants/constants.js';
  import AppLinks from '@/components/footer/AppLinks.vue';
  import { appResolution, apps } from '@/constants/app.constants';

  const { t } = useI18n();

  const footerCopyrightText = computed( () => {
    return Constants.app.name + ' '
      + Constants.version.toString
      + ' - ' + t( 'Copyright' ) + ' - '
      +  t( 'All Right Reserved' );
  } );
</script>